<template>
  <div id="app">
    <!-- 头部导航栏开始 -->
    <header>
      <div class="header">
        <div class="login">
          <div class="main_login">
            <div></div>
            <div style="display: flex; align-items: center">
              <div>
                <div class="sign-out" v-if="userInfo.token">
                  <div class="userName">{{ userInfo.userName }}，您好</div>
                  <div class="sign-outtext" @click="signoutBtn">退出</div>
                </div>
                <div class="login_R" v-else>
                  <div class="register" @click="RegisterBtn">注册</div>
                  <div style="padding: 0 10px; color: #fff">|</div>
                  <div class="loginBtn" @click="dialogVisible = true">登录</div>
                </div>
              </div>
              <div class="Personal" @click="toBecomeApartner">个人中心</div>
            </div>
          </div>
        </div>
        <div class="nav">
          <div class="mian_nav">
            <div class="logoIcon" @click="toindex">
              <img :src="WebsiteInfo.webLogo" alt="" />
            </div>
            <div class="navList">
              <div
                class="navItem"
                v-for="(item, index) in navItem"
                :key="index"
                @click="selectNav(index)"
                @mouseenter="mouseenter(index)"
                @mouseleave="mouseleave(index)"
              >
                {{ item.name }}
              </div>
              <div :class="[lastItem ? 'drop-down' : 'lastItemstyle']">
                <div class="down_main">
                  <div
                    class="down_menuItem"
                    v-for="(item, index) in NavClassList"
                    :key="index"
                  >
                    <div class="down_menutitle">
                      {{ item.navigationTwoClassPojo.twoClassName }}
                    </div>
                    <div class="down_menuList">
                      <div
                        class="listItem"
                        v-for="(xtem, xndex) in item.contentPojos"
                        :key="xndex"
                        @click="toDetailsLink(xtem.contentId, xtem.oneTitle)"
                      >
                        {{ xtem.oneTitle }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a href="http://www.jztyshop.com" class="links" target="_blank"></a>
    </header>
    <!-- 头部导航栏结束 -->
    <!-- 内容部分开始 -->
    <div class="contentBox">
      <router-view />
    </div>
    <!-- 内容部分结束 -->
    <!-- 底部开始 -->
    <footer>
      <div class="footer">
        <div class="footer_main">
          <div
            class="footerItem"
            v-for="(item, index) in Footertitle"
            :key="index"
          >
            <div style="display: flex">
              <div class="footer_title">
                {{ item.bottomClassPojo.className }}
              </div>
            </div>
            <div
              class="footerItem_title"
              v-for="(xtem, xndex) in item.bottomInfoPojoList"
              :key="xndex"
              @click="tolink(xtem.bottomInfoId, xtem.bottomName)"
            >
              {{ xtem.bottomName }}
            </div>
          </div>
          <div class="codeBox">
            <div class="codeImage">
              <img :src="WebsiteInfo.codeUrl" alt="" />
            </div>
            <div class="codeName">关注九州官方微信</div>
          </div>
        </div>
      </div>
      <div class="websiteInfo">
        <span>{{ WebsiteInfo.copyright }}</span>
        <span style="padding: 0 20px">{{ WebsiteInfo.webName }}</span>
        <div class="CopyrightIcon">
          <div class="icon"><img src="./assets/img/badge.png" alt="" /></div>
          <span style="padding-right:10px">京公网安备</span>
          <a class="linkUrl" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802036859">{{ WebsiteInfo.icpNum }}</a>
          <span style="padding:0 10px">|</span>
          <a class="linkUrl" target="_blank" href="https://dxzhgl.miit.gov.cn/#/home">{{ WebsiteInfo.icpNum2 }}</a>
          <span style="padding:0 10px">|</span>
          <a class="linkUrl" target="_blank" href="https://dxzhgl.miit.gov.cn/#/home">{{ WebsiteInfo.zengzhidianxin }}</a>
        </div>
        <!-- <span>{{WebsiteInfo.icpNum}}</span> -->
      </div>
    </footer>
    <!-- 底部结束 -->
    <!-- 登录开始 -->
    <div class="loginBox">
      <el-dialog
        :visible.sync="dialogVisible"
        width="480px"
        :close-on-click-modal="false"
      >
        <div class="fromBox">
          <div class="login_title">账号登陆</div>
          <div class="inputBox">
            <i class="el-icon-user-solid"></i>
            <input
              type="text"
              placeholder="请输入您的账号名称"
              v-model="userName"
            />
          </div>
          <div class="inputBox">
            <i class="el-icon-lock"></i>
            <input
              type="password"
              placeholder="请输入您的密码"
              v-model="password"
            />
          </div>
          <div class="codeBox">
            <input type="text" placeholder="请输入验证码" v-model="code" />
            <div class="code">
              <identify :identifyCode="identifyCode"></identify>
            </div>
          </div>
          <div class="replace" @click="changeCode()">看不清？换一换</div>
          <div class="loginBtn" @click="loginBtn">登录</div>
          <div class="registerBox">
            <div></div>
            <div class="register_R">
              <div class="forgetBox" @click="toReset">忘记密码</div>
              <div class="registerBtn">
                还没有账号？<span style="color: #1373cf" @click="toRegister"
                  >注册</span
                >
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 登录结束 -->
  </div>
</template>

<script>
import identify from "./components/SIdentify.vue";
import utils from "./assets/js/util.js";
export default {
  components: {
    identify,
  },
  data() {
    return {
      navItem: [
        // { name: "首页" },
        { name: "产品技术" },
        { name: "服务支持" },
        { name: "解决方案" },
        { name: "客户培训" },
        { name: "合作伙伴" },
        { name: "产品发布" },
        { name: "关于我们" },
        { name: "九州商城" },
      ],
      identifyCode: "m6a8", // 这个就是随机生成的验证码
      // 验证码的随机取值范围
      identifyCodes: "123456789abcdefghjkmnpqrstuvwxyz",
      dialogVisible: false,
      userName: "",
      password: "",
      code: "",
      userInfo: {},
      NavClassList: [],
      page: 1,
      limit: 100,
      Footertitle: [],
      WebsiteInfo: {},
      lastItem: true,
      PageIndex: -1,
    };
  },
  created() {
    this.getFooterInfo();
    this.getWebsiteInfo();
    this.getNavigationLink();
  },
  mounted() {
    // 刷新页面就生成随机验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    if (JSON.parse(localStorage.getItem("userInfo"))) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      // console.log(this.userInfo)
    }
  },
  methods: {
    toBecomeApartner() {
      this.$router.push({ path: "/BecomeApartner" });
    },
    tolink(id, name) {
      if (this.$route.path == "/Bottom-navDetail") {
        // this.$parent.getDetail(id)
        utils.$emit("getDatas", { bottomInfoId: id, bottomName: name });
        // location.href = "http://localhost:8080/#/product-Item?contentId="+id+"&contentName="+name
        // location.reload()
      } else {
        this.$router.push({
          path: "/Bottom-navDetail",
          query: { bottomInfoId: id, bottomName: name },
        });
      }
    },
    toDetailsLink(id, name) {
      if (this.$route.path == "/product-Item") {
        // this.$parent.getDetail(id)
        // console.log(2222222222)
        console.log(this.PageIndex);
        if (this.PageIndex == 5) {
          utils.$emit("getDatas", {
            contentId: id,
            contentName: name,
            PageType: 1,
          });
        } else {
          utils.$emit("getDatas", { contentId: id, contentName: name });
        }
        // location.href = "http://localhost:8080/#/product-Item?contentId="+id+"&contentName="+name
        // location.reload()
      } else {
        if (this.PageIndex == 5) {
          this.$router.push({
            path: "/product-Item",
            query: { contentId: id, contentName: name, PageType: 1 },
          });
        } else {
          this.$router.push({
            path: "/product-Item",
            query: { contentId: id, contentName: name },
          });
        }
      }
    },
    //忘记密码
    toReset() {
      this.dialogVisible = false;
      this.$router.push({ path: "/Reset" });
    },
    //导航详情链接
    getNavigationLink() {
      let url = "/navigationController/front/searchContentInfo";
      this.$axios
        .get(url, {
          params: {
            contentId: 2,
          },
        })
        .then((res) => {
          console.log(res);
        });
    },
    // 网站信息
    getWebsiteInfo() {
      let url = "/webInfoController/searchWebInfo";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.WebsiteInfo = res.data.data;
      });
    },
    //注册
    toRegister() {
      this.dialogVisible = false;
      this.$router.push({ path: "/Register" });
    },
    //点击验证码刷新验证码
    changeCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
    randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 随机生成验证码字符串
    makeCode(data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)];
      }
    },
    //底部信息
    getFooterInfo() {
      let url = "/bottomController/front/searchBottomNavigation";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.Footertitle = res.data.data;
      });
    },
    //退出登录
    signoutBtn() {
      this.$alert("是否退出登录？", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.$message({
              type: "success",
              message: "退出成功",
            });
            localStorage.removeItem("userInfo");
            this.$router.go(0);
          } else {
            this.$message({
              type: "error",
              message: "取消退出",
            });
          }
        },
      });
    },
    //登录
    loginBtn() {
      if (this.userName.trim() == "") {
        this.$message({
          showClose: true,
          message: "请输入账号",
          type: "error",
        });
        return false;
      }
      if (this.password.trim() == "") {
        this.$message({
          showClose: true,
          message: "请输入密码",
          type: "error",
        });
        return false;
      }
      if (this.code.trim() == "") {
        this.$message({
          showClose: true,
          message: "请输入验证码",
          type: "error",
        });
        return false;
      }
      if (this.code != this.identifyCode) {
        this.$message({
          showClose: true,
          message: "输入验证码错误",
          type: "error",
        });
        return false;
      }
      let url = "/userController/front/userLogin";
      this.$axios
        .post(url, {
          userName: this.userName,
          password: this.password,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 20000) {
            localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            this.$message({
              showClose: true,
              message: "登录成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$router.go(0);
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
          }
        });
    },
    //头部导航栏分类列表
    getNavList(index) {
      if (index == 6) {
        // console.log(index)
        let url = "/videoController/front/searchVideoClassList";
        this.$axios.get(url).then((res) => {
          console.log(res);
          this.NavClassList = res.data.data;
        });
        return false;
      } else {
        if (index == 7) {
          index = 6;
        }
        let url = "/navigationController/front/searchNavigation";
        this.$axios
          .get(url, {
            params: {
              type: index,
            },
          })
          .then((res) => {
            console.log(res);
            this.NavClassList = res.data.data;
          });
      }
    },
    mouseleave(e) {
      if (this.navItem.length - 1 == e) {
        this.lastItem = true;
        return;
      }
    },
    mouseenter(e) {
      // console.log(e)
      this.PageIndex = e;
      // console.log(this.navItem.length-1,e)
      if (this.navItem.length - 1 == e) {
        this.lastItem = false;
        return;
      }
      this.getNavList(e + 1);
    },
    RegisterBtn() {
      this.$router.push({ path: "/Register" });
    },
    toindex() {
      this.$router.push({ path: "/" });
    },
    selectNav(index) {
      if (index == 0) {
        this.$router.push({ path: "/Product-technology" });
        return false;
      }
      if (index == 1) {
        this.$router.push({ path: "/ServiceSupport" });
        return false;
      }
      if (index == 2) {
        this.$router.push({ path: "/Solution" });
        return false;
      }
      if (index == 3) {
        this.$router.push({ path: "/Customer-training" });
        return false;
      }
      if (index == 4) {
        this.$router.push({ path: "/cooperative-partner" });
        return false;
      }
      if (index == 5) {
        this.$router.push({ path: "/video-list" });
        console.log(index);
        return false;
      }
      if (index == 6) {
        this.$router.push({ path: "/About-us" });
        return false;
      }
      if (index == 7) {
        console.log(location.href);
        // window.location.href="http://www.jztyshop.com"
        let target = document.querySelector(".links");
        target.click();
        // return false;
      }
    },
  },
};
</script>
<style lang="less">
body {
  margin: 0;
  padding: 0;
}
#app {
  //头部开始
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    box-shadow: -5px -5px 10px #888888;
    .login {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 42px;
      background: #1373cf;
      .main_login {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        height: 100%;
        .Personal {
          font-size: 14px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          line-height: 21px;
          margin-left: 20px;
          cursor: pointer;
        }
        .sign-out {
          display: flex;
          align-items: center;
          .userName {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #ffffff;
          }
          .sign-outtext {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #ffffff;
            margin-left: 47px;
            cursor: pointer;
          }
        }
        .login_R {
          display: flex;
          align-items: center;
          .register {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
          .loginBtn {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
    }
    .nav {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100px;
      background: #ffffff;
      .mian_nav {
        margin: 0 auto;
        width: 1200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logoIcon {
          width: 177px;
          height: 78px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .navList {
          display: flex;
          align-items: center;
          .el-menu.el-menu--horizontal {
            border: 0;
          }
          .navItem {
            font-size: 18px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
            padding: 40px 18px;
            cursor: pointer;
          }
          .lastItemstyle {
            position: absolute;
            top: 100px;
            left: 0;
            right: 0;
            background-color: #f0f0f0;
            overflow: hidden;
            width: 100%;
            max-height: 0;
          }
          .drop-down {
            position: absolute;
            top: 100px;
            left: 0;
            right: 0;
            background-color: #f0f0f0;
            overflow: hidden;
            width: 100%;
            max-height: 0;
            transition: max-height 0.5s ease-out;
            .down_main {
              display: flex;
              // justify-content: space-between;
              width: 1200px;
              margin: 0 auto;
              overflow: hidden;
              padding: 30px 0;
              box-sizing: border-box;
              .down_menuItem {
                border-right: 1px solid #d6d6d6;
                // margin-right: 100px;
                width: 400px;
                padding: 0 20px;
                box-sizing: border-box;
                .down_menutitle {
                  font-size: 18px;
                  font-family: NotoSansHans-Regular, NotoSansHans;
                  font-weight: 400;
                  color: #1373cf;
                  margin-bottom: 20px;
                }
                .down_menuList {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  flex-wrap: wrap;
                  width: 400px;
                  .listItem {
                    // display: flex;
                    width: 160px;
                    font-size: 14px;
                    font-family: NotoSansHans-Regular, NotoSansHans;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 10px;
                    cursor: pointer;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                  .listItem:nth-child(even) {
                    padding-right: 30px;
                    box-sizing: border-box;
                  }
                  .listItem:hover {
                    color: #1373cf;
                  }
                }
              }
            }
          }
          .navItem:nth-last-child(1) {
            padding-right: 0;
          }
          .navItem:hover {
            color: #1373cf;
          }
          .hidden-xs:hover {
            display: block;
          }
          .currentColor {
            color: #1373cf;
            font-weight: 500;
          }
        }
        .navList:hover .drop-down {
          max-height: 500px;
          transition-delay: 0.7s;
        }
      }
    }
  }
  // 头部结束
  .contentBox {
    padding-top: 142px;
  }
  // 底部开始
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 260px;
    background: #1373cf;
    margin-top: 60px;
    .footer_main {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      width: 1200px;
      // margin: 0 auto;
      .footerItem {
        .footer_title {
          font-size: 18px;
          font-family: NotoSansHans-Medium, NotoSansHans;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 15px;
        }
        .footerItem_title {
          font-size: 14px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          margin-bottom: 5px;
          cursor: pointer;
        }
        .footerItem_title:hover {
          opacity: 0.8;
        }
      }
      .codeBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .codeImage {
          width: 124px;
          height: 124px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .codeName {
          font-size: 14px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          margin-top: 15px;
        }
      }
    }
  }
  .websiteInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    margin: 0 auto;
    padding: 14px 0;
    text-align: center;
    font-size: 14px;
    font-family: NotoSansHans-Regular, NotoSansHans;
    font-weight: 400;
    color: #333333;
    .linkUrl{
      font-size: 14px;
      color: #333333;
      text-decoration: none;
    }
    .linkUrl:hover{
      color: #1373cf;
    }
    .CopyrightIcon {
      display: flex;
      align-items: center;
      .icon {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // 底部结束
  .loginBox {
    .fromBox {
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      // align-items: center;
      padding: 0 15px 80px 15px;
      .login_title {
        font-size: 24px;
        font-family: NotoSansHans-Medium, NotoSansHans;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-bottom: 48px;
      }
      .inputBox {
        display: flex;
        align-items: center;
        width: 380px;
        height: 50px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #e6e8ed;
        padding: 0 14px;
        margin-bottom: 24px;
        .el-icon-user-solid {
          font-size: 30px;
          margin-right: 10px;
          color: #999999;
        }
        .el-icon-lock {
          font-size: 30px;
          margin-right: 10px;
          color: #999999;
        }
        input {
          width: calc(380px - 40px);
          height: 90%;
          border: 0;
          font-size: 14px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #999999;
          outline: 0;
        }
      }
      .codeBox {
        display: flex;
        align-items: center;
        input {
          width: 180px;
          height: 50px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #e6e8ed;
          margin-right: 16px;
          outline: 0;
          padding: 0 16px;
        }
        .code {
          width: 180px;
          height: 50px;
          border-radius: 4px;
          // border: 1px solid #E6E8ED;
          text-align: center;
          line-height: 50px;
        }
      }
      .replace {
        font-size: 12px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #1373cf;
        text-align: end;
        padding: 10px 0;
        cursor: pointer;
      }
      .loginBtn {
        width: 410px;
        height: 60px;
        background: #1373cf;
        border-radius: 4px;
        font-size: 18px;
        font-family: NotoSansHans-Medium, NotoSansHans;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 60px;
        margin: 68px auto 0;
        cursor: pointer;
      }
      .registerBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 0 0 0;
        .register_R {
          display: flex;
          align-items: center;
          .forgetBox {
            font-size: 12px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #999999;
            margin-right: 30px;
            cursor: pointer;
          }
          .registerBtn {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #999999;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
